import React from "react";
import Button from "@/components/ui/Button";
import { URLS } from "@/lib/consts";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { LogoProps } from "./types";

function Logo({
  src = "orsak-cpas-logo",
  alt = "Orsak CPAs Logo",
  href = URLS.HOME,
  presetRatio = "very-long",
  "aria-label": ariaLabel = "Orsak CPAs Logo - Click to go to the Home Page",
  className,
  ...props
}: LogoProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Button.Image
      src={src}
      alt={alt}
      aria-label={ariaLabel}
      href={href}
      presetRatio={presetRatio}
      aspectRatioProps={{ className: "w-[250px]" }}
      className={cn(className, classes)}
      {...native}
    />
  );
}

export default Logo;
